import { pendoProductAreas, apps } from 'appConstants';

export const defaultMetadata = {
    app: apps.BROWSER_EXTENSION,
    productArea: pendoProductAreas.TEXT_ENGAGEMENT
};
